module.exports = __webpack_public_path__ + "assets/img/goToAccomplish.9cc9f663.png";